import React from 'react'

export default props => (
    <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14.75 14.48"
        {...props}
    >
        <path
            d="M986,510.48a5.15,5.15,0,0,0-7.27,0,4.88,4.88,0,0,0-1.48,3.2H978a4.17,4.17,0,0,1,.49-1.6l.61.36.19-.32-.62-.37A4.08,4.08,0,0,1,980,510.4l.37.62.32-.18-.37-.62a4.26,4.26,0,0,1,1.86-.51v.74h.37v-.74a4.26,4.26,0,0,1,1.85.51l-.36.62.32.18.36-.62a3.45,3.45,0,0,1,.76.6,3.73,3.73,0,0,1,.6.75l-.62.37.18.32.62-.36a4.26,4.26,0,0,1,.51,1.85H986v.37h.74a4.26,4.26,0,0,1-.51,1.86l-.62-.37-.18.32.62.37a3.73,3.73,0,0,1-.6.75,3.45,3.45,0,0,1-.76.6l-.36-.62-.32.18.36.62a4.1,4.1,0,0,1-1.79.5v.73a5.14,5.14,0,0,0,3.39-8.76Z"
            transform="translate(-972.74 -508.98)"
        />
        <path
            d="M982,511.91v1.56a.73.73,0,0,0-.37.65.72.72,0,0,0,.73.73.72.72,0,0,0,.62-.34h2.68v-.74H983a.82.82,0,0,0-.28-.3v-1.56Z"
            transform="translate(-972.74 -508.98)"
        />
        <path
            d="M980.88,513.4h-7a1.18,1.18,0,0,0-1.12,1.13v2.23h1.12v-2.23H981A1.82,1.82,0,0,1,980.88,513.4Z"
            transform="translate(-972.74 -508.98)"
        />
        <path
            d="M982.27,515.59a1.1,1.1,0,0,1-.61-.18v6.92h-7.8v-2.22h-1.12v2.22a1.08,1.08,0,0,0,.34.79,1,1,0,0,0,.78.34h7.8a1.16,1.16,0,0,0,1.13-1.13v-6.87A1.08,1.08,0,0,1,982.27,515.59Z"
            transform="translate(-972.74 -508.98)"
        />
        <polygon points="3.95 11.47 4.74 12.25 7.54 9.45 4.74 6.65 3.95 7.44 5.42 8.9 0 8.9 0 10 5.39 10 3.95 11.47" />
    </svg>
)
